export const RestaurantPaymentMethodTypes = {
    PIDE_DIRECTO: 'PIDE_DIRECTO',
    RESTAURANT: 'RESTAURANT',
} as const;

export type RestaurantPaymentMethodType = (typeof RestaurantPaymentMethodTypes)[keyof typeof RestaurantPaymentMethodTypes];
